document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.testimonial-carousel .carousel-track');
  if (!track) return;

  const items = Array.from(track.children);
  const prevBtn = document.querySelector('.testimonial-carousel .carousel-btn.prev');
  const nextBtn = document.querySelector('.testimonial-carousel .carousel-btn.next');
  const container = document.querySelector('.testimonial-carousel .carousel-container');

  let index = 1; // comenzamos desde el primer slide real
  const firstClone = items[0].cloneNode(true);
  const lastClone = items[items.length - 1].cloneNode(true);

  // Agregamos clones para el bucle infinito
  track.appendChild(firstClone);
  track.insertBefore(lastClone, items[0]);

  const allSlides = Array.from(track.children);
  let slideWidth = items[0].getBoundingClientRect().width;

  // Posicionamos en el primer slide real
  track.style.transform = `translateX(-${slideWidth * index}px)`;
  track.style.transition = 'transform 0.6s ease-in-out';

  // Funciones
  function moveToSlide() {
    track.style.transform = `translateX(-${slideWidth * index}px)`;
  }

  function nextSlide() {
    if (index >= allSlides.length - 1) return;
    index++;
    moveToSlide();
  }

  function prevSlide() {
    if (index <= 0) return;
    index--;
    moveToSlide();
  }

  // Ajuste infinito
  track.addEventListener('transitionend', () => {
    if (allSlides[index] === firstClone) {
      track.style.transition = 'none';
      index = 1;
      moveToSlide();
      setTimeout(() => track.style.transition = 'transform 0.6s ease-in-out');
    }

    if (allSlides[index] === lastClone) {
      track.style.transition = 'none';
      index = allSlides.length - 2;
      moveToSlide();
      setTimeout(() => track.style.transition = 'transform 0.6s ease-in-out');
    }
  });

  // Botones
  nextBtn.addEventListener('click', nextSlide);
  prevBtn.addEventListener('click', prevSlide);

  // Recalcular tamaño al redimensionar
  window.addEventListener('resize', () => {
    slideWidth = items[0].getBoundingClientRect().width;
    track.style.transition = 'none';
    moveToSlide();
    setTimeout(() => track.style.transition = 'transform 0.6s ease-in-out');
  });

  // Movimiento automático
  let autoSlide = setInterval(nextSlide, 5000);

  // Pausar al pasar el mouse
  container.addEventListener('mouseenter', () => {
    clearInterval(autoSlide);
  });

  // Reanudar al quitar el mouse
  container.addEventListener('mouseleave', () => {
    autoSlide = setInterval(nextSlide, 5000);
  });
});


/*SOCIOS*/
document.addEventListener("DOMContentLoaded", () => {
  const track = document.querySelector(".partners-track");
  const grid = document.querySelector(".partners-grid");

  if (!track || !grid) return;

  // Duplicar logos en línea para efecto infinito
  const clone = grid.cloneNode(true);
  track.appendChild(clone);
});

